
export const content = {
    title: "Your value from the boot camps",
    subtitle: "Our mission is to help your organization understand the business and customer value",
    items: [
        {
            title: "Inspire",
            iconName: "fa-2x far fa-lightbulb",
            text: "By understanding your organizationneeds, Altola highlight how Sitecore can be used and inspire on use cases"
        },
        {
            title: "POC",
            iconName: "fa-2x fas fa-puzzle-piece",
            text: "We provide proof of concept for select scenarios and highlight how you can get started correct"
        },
        {
            title: "Business case",
            iconName: "fa-2x fas fa-briefcase",
            text: "All scenarios is related to how Sitecore helps increase business outcomes and help you be more operational efficient"
        }
    ]
};

export default content;


// WEBPACK FOOTER //
// ./src/content/components/value-bootcamp.js